<template>
  <m-widget-head>
    <nav>
      <results-menu style="margin-right: 5px;"/>
      <!--active-button
        :active="isActive('page', 'upcoming')"
        @click="$router.push('/live/upcoming')"
        style="margin-right: -5px;"
      >
        <div>&nbsp;{{ $t('live.upcoming') }}&nbsp;</div>
      </active-button-->
      <active-button
        @click="openStatistics()"
      >
        <span v-if="this.$i18n.locale === 'ru'">Статистика</span>
        <span v-if="this.$i18n.locale === 'en'">Statistics</span>
        <span v-if="this.$i18n.locale === 'az'">Oyunların analizi</span>
      </active-button>
      <!--active-button
        :active="isActive('page', 'upcoming')"
        @click="$router.push('/live/upcoming')"
      >
        {{ $t('live.upcoming') }}
      </active-button-->
      <!--active-button
        :active="isActive('page', 'rules')"
        @click="$router.push('/rules')"
      >
        {{ $t('menu.rules') }}
      </active-button-->
      <!--active-button
        :active="isActive('page', 'bonuses')"
        @click="$router.push('/bonuses')"
      >
        {{ $t('account.bonus') }}
      </active-button>
      <active-button
        :active="isActive('page', 'vip')"
        @click="$router.push('/vip')"
      >
        <span v-if="this.$i18n.locale === 'ru'">VIP-ставка</span>
        <span v-if="this.$i18n.locale === 'en'">VIP-bet</span>
        <span v-if="this.$i18n.locale === 'az'">VIP-mərc</span>
      </active-button-->
      <!--active-button
        @click="openChat()"
      >
        <span style="margin-top: 3px;">
          <svg width="15" height="12" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1V7C12 7.55228 11.5523 8 11 8C11 8 5 8 4 8C2.85832 8 1.49997 8.85465 0.696097 9.44658C0.418292 9.65114 0 9.45518 0 9.11019V1ZM2.5 2C2.22386 2 2 2.22386 2 2.5C2 2.77614 2.22386 3 2.5 3H9.5C9.77614 3 10 2.77614 10 2.5C10 2.22386 9.77614 2 9.5 2H2.5ZM2 4.5C2 4.22386 2.22386 4 2.5 4H6.5C6.77614 4 7 4.22386 7 4.5C7 4.77614 6.77614 5 6.5 5H2.5C2.22386 5 2 4.77614 2 4.5Z" fill="white"></path>
          </svg>
        </span>
        <span v-if="$i18n.locale === 'ru'">Чат</span>
        <span v-if="$i18n.locale === 'en'">Chat</span>
        <span v-if="$i18n.locale === 'az'">Canlı dəstək</span>
      </active-button-->
    </nav>
    <div class="time" style="margin-top: 6px; margin-left: 10px; font-size: 14px; word-break: break-all; float: right; margin-right: 20px;" :key="localeDate">{{ this.localeDate | moment('HH:mm:ss') }}</div>
    <language-switcher />
  </m-widget-head>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import LanguageSwitcher from '@/components/header/LanguageSwitcher'
import Search from '@/components/header/Search'
import ResultsMenu from '@/components/header/ResultsMenu'
import { mapState } from 'vuex'

export default {
  components: { ActiveButton, LanguageSwitcher, Search, ResultsMenu },
  computed: {
    ...mapState({
      favoritesQ: state => state.favorites.quantity,
      isUserLoggedIn: state => state.isUserLoggedIn
    })
  },
  data () {
    return {
      intervalId: null,
      localeDate: ''
    }
  },
  mounted () {
    this.intervalId = setInterval(this.getNow, 1000)
  },
  methods: {
    followResults () {
      this.$router.push('/results/date/' + (new Date(Date.now() + 3600000 * 3)).toISOString().split('T')[0])
    },
    openChat () {
      window.location.assign('javascript:void(Tawk_API.toggle())')
    },
    openStatistics () {
      window.open('http://statistic.sportdemo.ru/betspectrumStatistics?lang=' + this.$i18n.locale, 'statistics', 'width=1000,height=700,menubar=no,toolbar=no,location=no')
    },
    getNow: function () {
      const today = new Date()
      const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      const timer = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
      this.localeDate = date + ' ' + timer
    }
  }
}
</script>

<style scoped>
nav { display: flex; margin-right: 10px; float: left; }
nav .active-button { color: #fff; font-size: 13px; height: 30px; line-height: 30px !important; }
</style>



// WEBPACK FOOTER //
// src/components/header/DopMenu.vue